import { useState, useEffect } from "react";

import { FetchService } from "../../../../API/FetchService.js";

import { FetchComponent } from "../../../FetchComponent/FetchComponent.jsx";

import { ModuleList } from "./ModuleList/ModuleList.jsx";

export const CabinetModule = ({ user, student }) => {
  const { ref, role } = user;
  const [responseData, setResponseData] = useState({
    data: [],
    loading: true,
    error: false,
  });
  const { data, loading, error } = responseData;

  useEffect(() => {
    new FetchService({ ref, role })
      .getPersonModules()
      .then(({ data }) => {
        setResponseData((prev) => {
          return { ...prev, data };
        });
      })
      .catch(() => {
        setResponseData((prev) => {
          return { ...prev, error: true };
        });
      })
      .finally(() => {
        setResponseData((prev) => {
          return { ...prev, loading: false };
        });
      });
  }, [ref, role]);

  return (
    <>
      <h1 className="mb-2 text-center">Образовательные модули</h1>
      <FetchComponent
        keyAnimation={loading}
        loading={loading}
        error={error}
        heightContainer="20vh"
      >
        <ModuleList data={data} student={student} />
      </FetchComponent>
    </>
  );
};
